import React, {useState} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface FormDatePickerProps {
  label: string;
  selectedDate: Date | null;
  onChange: (date: Date | null) => void;
  showTime?: boolean;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

export const FormDatePicker: React.FC<FormDatePickerProps> = ({
  label,
  selectedDate,
  onChange,
  showTime = true,
  required = false,
  placeholder = 'Select date and time...',
  disabled = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // Custom CSS to inject to override library defaults
  const calendarStyles = `
    .react-datepicker {
      background-color: #2a2a2a;
      border: 1px solid #444;
      font-family: inherit;
      color: #fff;
    }
    .react-datepicker__header {
      background-color: #1a1a1a;
      border-bottom: 1px solid #333;
    }
    .react-datepicker__current-month, .react-datepicker__day-name, .react-datepicker__day {
      color: #fff !important;
    }
    .react-datepicker__day:hover {
      background-color: #444 !important;
    }
    .react-datepicker__day--selected {
      background-color: #daff00 !important;
      color: #000 !important;
    }
    .react-datepicker__time-container {
      border-left: 1px solid #333 !important;
      background-color: #2a2a2a !important;
    }
    .react-datepicker__time {
      background-color: #2a2a2a !important;
      color: #fff !important;
    }
    .react-datepicker-time__header {
      color: #fff !important;
    }
  `;

  return (
    <div style={{marginBottom: '20px', width: '100%'}}>
      <style>{calendarStyles}</style>

      <label
        style={{
          display: 'block',
          color: '#aaa',
          fontSize: '0.78rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          marginBottom: '6px',
        }}>
        {label} {required && <span style={{color: '#daff00'}}>*</span>}
      </label>

      <div
        onMouseEnter={() => { if (!disabled) setIsHovered(true); }}
        onMouseLeave={() => setIsHovered(false)}
        style={{width: '100%', opacity: disabled ? 0.4 : 1, cursor: disabled ? 'not-allowed' : undefined}}>
        <DatePicker
          selected={selectedDate}
          onChange={onChange}
          showTimeSelect={showTime}
          dateFormat={showTime ? 'EEEE, d MMM, yyyy HH:mm' : 'P'}
          timeFormat="HH:mm"
          placeholderText={placeholder}
          required={required}
          disabled={disabled}
          className="dash-datepicker-input"
          autoComplete="off"
          timeIntervals={5}
          injectTimes={[new Date(new Date().setHours(0, 0, 0, 0))]}
        />
      </div>

      <style>
        {`
          .dash-datepicker-input {
            width: 100% !important;
            height: 46px;
            padding: 0 16px;
            border-radius: 8px;
            border: 1px solid ${isHovered ? '#daff00' : '#333'};
            background-color: #2a2a2a;
            color: #fff;
            font-size: 0.9rem;
            outline: none;
            box-sizing: border-box;
            transition: border-color 0.2s ease;
            cursor: pointer;
          }
          .dash-datepicker-input:disabled {
            cursor: not-allowed;
          }
          /* Fix for the wrapper width */
          .react-datepicker-wrapper {
            width: 100%;
          }

          /* 1. Fix Time List Hover Colors */
            .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
            background-color: #444 !important; /* Darker gray on hover */
            color: #daff00 !important;      /* Lime green text on hover */
            }

            /* 2. Fix the Selected Time Item */
            .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
            background-color: #daff00 !important;
            color: #000 !important;
            font-weight: bold;
            }

            /* 3. Ensure the Time Container background is dark */
            .react-datepicker__time-container,
            .react-datepicker__time,
            .react-datepicker__time-box {
            background-color: #2a2a2a !important;
            border-radius: 0 8px 8px 0;
            }

            /* 4. Fix Triangle/Arrow pointer color */
            .react-datepicker__popper[data-placement^="bottom"] .react-datepicker__triangle::before,
            .react-datepicker__popper[data-placement^="bottom"] .react-datepicker__triangle::after {
            border-bottom-color: #1a1a1a !important;
                }
        `}
      </style>
    </div>
  );
};
